import { docType } from './constants';

export const deleteDocModal = async (type: docType): Promise<boolean> => {
  return window.confirm(`Are you sure you want to delete this ${type}? This action is not reversible`);
};

export const deleteModal = async (message: string): Promise<boolean> => {
  return window.confirm(message);
};
